import { render, staticRenderFns } from "./ProductSideSheet.vue?vue&type=template&id=d9da9d56&scoped=true"
import script from "./ProductSideSheet.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductSideSheet.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductSideSheet.vue?vue&type=style&index=0&id=d9da9d56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9da9d56",
  null
  
)

export default component.exports